// BlurVignette.jsx
import styles from './blurVignette.module.css';

const BlurVignette = ({
    inset = '8px',
    transitionLength = '300px',
    blur = '15px',
    className,
    style,
    ...props
}) => {
    return (
        <div
            className={`${styles.blurVignette} ${className || ''}`}
            style={{
                '--inset': inset,
                '--transition-length': transitionLength,
                '--blur': blur,
                position: 'fixed',
                zIndex: 3,
                pointerEvents: 'none',
                ...style
            }}
            {...props}
        />
    );
};

export default BlurVignette;